import React from 'react';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import {
  selectLoading,
  selectMetrics,
  selectSelectedMetric,
  updateSelectedMetric,
} from '../../features/filters/metricsSlice';
import { fetchMapMetrics } from '../../features/map/mapSlice';
import { hideLoader, showLoader } from '../../features/ui/loaderSlice';
import { DynamicDropdown } from '../UI/DynamicDropdown/DynamicDropdown';

const MetricsDropdown: React.FC = () => {
  const dispatch = useAppDispatch();
  const metrics = useAppSelector(selectMetrics);
  const selectedMetric = useAppSelector(selectSelectedMetric);
  const loading = useAppSelector(selectLoading);
  const filtersState = useAppSelector((state) => state.filters);

  const handleMetricChange = async (newSelected: string[]) => {
    await dispatch(showLoader());
    await dispatch(updateSelectedMetric(newSelected));
    const payload = {
      category: filtersState.enabledKeys.category,
      metric: newSelected[0],
    };
    await dispatch(fetchMapMetrics(payload));
    await dispatch(hideLoader());
  };

  return (
    <>
      <DynamicDropdown
        label="Metrics"
        options={metrics}
        selectedOptions={selectedMetric}
        onChange={handleMetricChange}
        customStyle={{
          width: '86px',
          height: '23px',
          border: `1px solid grey !important`,
          borderBottom: '0.8px solid grey !important',
        }}
        multiple={false}
        disabled={loading}
        borderColor={'#E81C0E'}
      />
    </>
  );
};

export default MetricsDropdown;
